<template>
  <div class="account">
    <Dislog ref="dislog" :type="type" :id='id' @resh="turnpage(1)"></Dislog>
    <div class="top wbg" v-if="$common.AUTH('arbitrate:index')">
      <div class="group">
        <a-form-model ref="ruleForm" :model="form">
          <div class="label">
            仲裁机构名称：
            <a-input v-model="form.title" placeholder="请输入仲裁机构名称" style="width: 167px">
            </a-input>
          </div>
          <div class="allbtns">
            <a-button icon="search" class="ant-btn" @click="query(1)">查询</a-button>
            <a-button style="min-width: 64px;" @click="reset">重置</a-button>
            <a-button icon="plus" @click="show(1)" v-if="$common.AUTH('arbitrate:add')">新增</a-button>
          </div>
        </a-form-model>
      </div>
    </div>
    <div class="tcon wbg" v-if="$common.AUTH('arbitrate:index')">
      <div class="tableList">
        <div class="ntable" v-for="i in data" v-if="i.list.length > 0">
          <table>
            <thead>
              <td width="200">仲裁机构名称</td>
              <td width="240">仲裁立案地址</td>
              <td width="200">操作</td>
            </thead>
            <tbody>
              <tr v-for="j in i.list">
                <td>{{ j.title }}</td>
                <td>{{ j.address }}</td>
                <td>
                  <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="del(j.id)"
                    v-if="$common.AUTH('arbitrate:del')">
                    <a href="javascript:void(0);">删除</a>
                  </a-popconfirm>
                  <span class="line"></span>
                  <a href="javascript:void(0);" v-if="$common.AUTH('arbitrate:edit')" @click="show(2, j.id)">修改</a>
                  <span class="line"></span>
                  <a href="javascript:void(0);" v-if="$common.AUTH('arbitrate:index')" @click="show(0, j.id)">查看</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="pages">
        <a-pagination v-model="form.page" :total="total" show-less-items show-quick-jumper :pageSize="20"
          @change="turnpage" :show-total="(total) => `小计 ${total}`" />
      </div>
    </div>
    <div class="nqx" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
  </div>
</template>
<script>
import { arbOrg } from '@/server/directory'
import Dislog from './dislog.vue'
export default {
  data() {
    return {
      form: { title: '', page: 1, limit: 20 },
      type: 0,
      id: null,
      data: {
        0: { list: [] },
        1: { list: [] },
      },
      total: 0,
    }
  },
  components: { Dislog },
  created() {
    this.query()
  },
  methods: {
    show(type, id) {
      if (id) {
        this.id = id + ''
        this.$refs.dislog.getInfo(id)
      }
      this.type = type;
      this.$refs.dislog.visible = true;
    },
    turnpage(val) {
      this.form.page = val
      this.query()
    },
    del(id) {
      arbOrg({ id: id }, 'del').then(e => {
        this.turnpage(1)
        this.$message.success("删除成功")
      })
    },
    query() {
      arbOrg(this.form, 'index').then((res) => {
        let arr = {
          0: { list: [] },
          1: { list: [] },
        }
        res.list.map((ele, index) => {
          ele.address = ele.province + ele.city + ele.area + ele.addr
          if (index < 10) {
            arr[0].list.push(ele)
          } else {
            arr[1].list.push(ele)
          }
        })
        this.data = arr
        this.total = res.count
      })
    },
    reset() {
      this.form.limit = 20
      this.form.page = 1
      this.form.title = ''
      this.query()
    }
  },
}
</script>
<style lang="less" scoped>
.account {
  @import url("@/assets/css/topForm");
}

.tcon {
  padding: 0 20px;
  min-height: 760px;

  .tableList {
    display: flex;
    justify-content: space-between;

    .ntable {
      flex: 1;
      margin-right: 20px;
      max-width: 50%;

      table {
        width: 100%;

        td {
          text-align: center;
        }
      }

      thead {
        td {
          height: 36px;
          background: #f4f5f9;
          border: 1px solid #efefef;
        }
      }

      tbody {
        border-right: 1px solid #efefef;

        td {
          height: 54px;
          border-bottom: 1px solid #efefef;
          border-left: 1px solid #efefef;

          .line {
            display: inline-block;
            width: 1px;
            height: 14px;
            background-color: #dbdcde;
            margin: 0 10px;
            vertical-align: middle;
          }
        }
      }

      &:nth-last-child(1) {
        margin: 0;
      }
    }
  }
}

.pages {
  text-align: right;
}

.modal-footer {
  text-align: center;

  .cancel {
    background-color: #b2c9e1;
    border-color: #b2c9e1;
    margin-left: 30px;
  }
}
</style>
